// https://vuex.vuejs.org/en/getters.html

export default {
  getUser: (state) => state.user,
  getIsSharingWhitelabels: (state) => state.isSharingWhitelabels,
  getIsInvite: (state) => state.isInvite,
  getUserSettings: (state) => state.userSettings,
  getUserPermissions: (state) => state.userPermissions,
  currentTariff: (state) => {
    return state.user && state.user.pricing_purchase ? state.user.pricing_purchase : null
  },
  isOwner: (state, getters, rootState, rootGetters) => {
    const whitelabel = rootGetters['whitelabel/getWhiteLabel'];
    const user = getters.getUser;
    if(whitelabel && user ) {
      return user.uuid === whitelabel.owner.uuid
    }
    return false
  }
};
